import { Form } from 'react-router'
import { z } from 'zod'
import { Icon } from '#app/components/ui/icon'
import { StatusButton } from '#app/components/ui/status-button'
import { useIsPending } from './misc'

export const GOOGLE_PROVIDER_NAME = 'google'
// to add another provider, set their name here and add it to the providerNames below

export const providerNames = [GOOGLE_PROVIDER_NAME] as const
export const ProviderNameSchema = z.enum(providerNames)
export type ProviderName = z.infer<typeof ProviderNameSchema>

export const providerLabels: Record<ProviderName, string> = {
	[GOOGLE_PROVIDER_NAME]: 'Google',
} as const

export const providerIcons: Record<ProviderName, React.ReactNode> = {
	[GOOGLE_PROVIDER_NAME]: (
		<img src="/img/google-icon.svg" className="w-4 h-4" alt="Google" />
	),
} as const

export function ProviderConnectionForm({
	redirectTo,
	type,
	providerName,
}: {
	redirectTo?: string | null
	type: 'Connect' | 'Login' | 'Continue'
	providerName: ProviderName
}) {
	const label = providerLabels[providerName]
	const formAction = `/auth/${providerName}`
	const isPending = useIsPending({ formAction })
	return (
		<Form
			className="flex items-center justify-center gap-2"
			action={formAction}
			method="POST"
		>
			{redirectTo ? (
				<input type="hidden" name="redirectTo" value={redirectTo} />
			) : null}
			<StatusButton
				type="submit"
				className={
					providerName === GOOGLE_PROVIDER_NAME
						? 'w-full border py-[16px] h-[55px] border-[#CCCCCC] rounded-[30px] cursor-pointer'
						: 'w-full cursor-pointer'
				}
				status={isPending ? 'pending' : 'idle'}
				variant={providerName === GOOGLE_PROVIDER_NAME ? 'ghost' : 'default'}
			>
				<span className="inline-flex items-center gap-1.5 text-[#32302F] text-[18px]">
					{providerIcons[providerName]}
					<span>
						{type} with {label}
					</span>
				</span>
			</StatusButton>
		</Form>
	)
}
